<template>
  <nav :class="themeRender">
    <form class="form-inline mr-auto">
      <ul class="navbar-nav mr-3">
        <li>
          <a @click="toggleSidebar" :class="themefas"
            ><i class="fas fa-bars"></i
          ></a>
        </li>
      </ul>
    </form>
    <ul class="navbar-nav navbar-right">
      <li class="dropdown">
        <a
          href="#"
          data-toggle="dropdown"
          class="nav-link dropdown-toggle nav-link-lg nav-link-flag"
        >
          <img class="img-fluid mr-1" :src="flagSrc" />
          <div class="d-sm-none d-lg-inline-block">
            {{
              this.currentLang == "th"
                ? $t("messages.general.lang.th")
                : $t("messages.general.lang.en")
            }}
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item has-image" @click="handleSwitchLocale">
            <img class="img-fluid mr-1" :src="flagSrcSwitch" />
            {{
              this.currentLang == "th"
                ? $t("messages.general.lang.en")
                : $t("messages.general.lang.th")
            }}
          </a>
        </div>
      </li>
      <li class="dropdown">
        <a
          href="#"
          data-toggle="dropdown"
          class="nav-link dropdown-toggle nav-link-lg nav-link-user"
        >
          <img
            alt="image"
            src="../assets/img/avatar/avatar-1.png"
            class="rounded-circle mr-1"
          />
          <div class="d-sm-none d-lg-inline-block">
            {{ displayName }}
          </div></a
        >
        <div class="dropdown-menu dropdown-menu-right">
          <!-- <router-link to="/" class="dropdown-item has-icon">
            <i class="far fa-user"></i> {{ $t("messages.general.userInfo") }}
          </router-link> -->
          <!-- <div class="dropdown-divider"></div> -->
          <a class="dropdown-item has-icon text-danger" @click="handleLogout">
            <i class="fas fa-sign-out-alt"></i>
            {{ $t("messages.general.logout") }}
          </a>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import thaiFlagSrc from "../assets/img/svg/th.svg";
import enFlagSrc from "../assets/img/svg/gb.svg";

export default {
  name: "NavBar",
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      theme: "getTheme",
      isAuth: "isAuth",
      isExpired: "isExpired",
      studentInfo: "getStudentInfo",
      studentId: "getStudentId",
      token: "getToken",
      sessionGuid: "getSessionGuid",
      seq: "getSeq"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    flagSrc: function() {
      return this.currentLang == "th" ? thaiFlagSrc : enFlagSrc;
    },
    flagSrcSwitch: function() {
      return this.currentLang == "th" ? enFlagSrc : thaiFlagSrc;
    },
    displayName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.USERNAME
        : `${this.studentInfo.data.PREFIXNAME} ${this.studentInfo.data.STUDENTNAME} ${this.studentInfo.data.STUDENTSURNAME}`;
    },
    isLoginAs: function() {
      return !_.isEmpty(this.studentInfo.data);
    }
  },
  data() {
    return {
      themeRender: "",
      themefas: ""
    };
  },
  mounted() {
    this.checkTheme();
    console.debug("appInfo nav", this.appInfo);
  },
  methods: {
    ...mapActions("application", [
      "setCurrentLocale",
      "initApplication",
      "setToken",
      "setCurrentUser",
      "setMenu",
      "logout",
      "clearToken",
      "toggleSidebar",
      "clearStudentInfo",
      "setSessionGuid",
      "setSeq"
    ]),
    handleSwitchLocale: function() {
      this.setCurrentLocale();
    },
    handleLogout: function() {
      if (this.isLoginAs) {
        this.clearStudentInfo();
        this.$router.push("/redirecthome");
      } else {
        if (this.token != "") {
          // let url = process.env.VUE_APP_API_ENDPOINT;
          // fetch(url + "reg/enroll/killsession", {
          //   method: "DELETE",
          //   headers: {
          //     Accept: "application/json",
          //     "Content-Type": "application/json",
          //     Authorization: `Bearer ${this.token}`
          //   },
          //   body: JSON.stringify({
          //     sessionguid: this.sessionGuid
          //   }),
          //   keepalive: true
          // });
          // this.setSessionGuid(false);
          // this.setSeq(false);
        }
        this.clearToken();
        this.$router.push("/redirecthome");
      }
    },
    checkTheme: function() {
      if (!this.isAuth || this.isExpired) {
        this.themeRender = "hidden";
      } else {
        this.themeRender = "navbar navbar-expand-lg main-navbar";
        const t = this.theme;
        switch (t) {
          case 1:
            this.themefas = "nav-link nav-link-lg temp-fas";
            break;
          case 0:
          default:
            this.themefas = "nav-link nav-link-lg";
            break;
        }
      }
    }
  },
  watch: {
    theme() {
      this.checkTheme();
    },
    isAuth() {
      this.checkTheme();
    },
    isExpired() {
      this.checkTheme();
    }
  }
};
</script>

<style scoped>
.hidden {
  display: none;
}
.temp-fas {
  color: rgba(11, 187, 236, 0.9) !important;
}
</style>
